/**
 * @file paddlex 下载按钮
 * @author FengGuang(fengguang01@baidu.com)
 */
import React, {useMemo} from 'react';
import {Button} from 'antd';
import A from '../../../../../../components/a/A';
import IconLinux from '../../../../img/linux.png';
import IconMac from '../../../../img/mac.png';
import IconWindows from '../../../../img/windows.png';

interface IDownloadIconProps {
    windows?: string;
    mac?: string;
    linux?: string;

    onDownloadClick?: (target: string, link: string) => void;
}


const DownloadIcons: React.FC<IDownloadIconProps> = props => {
    const {
        windows,
        mac,
        linux,

        onDownloadClick
    } = props;

    const [
        onWinClick,
        onMacClick,
        onLinuxClick
    ] = useMemo(() => {
        const generateOnClick = (target: string, link?: string) => {
            return () => {
                if ((window as any)._hmt) {
                    (window as any)._hmt.push(['_trackEvent', 'paddlex', '下载', target]);
                }
                onDownloadClick && onDownloadClick(target, link || '');
            };
        };
        return [
            generateOnClick('win', windows),
            generateOnClick('mac', mac),
            generateOnClick('linux', linux)
        ];
    }, [windows, mac, linux, onDownloadClick]);

    return (
        <div className="paddle-lab-download-icon-wrap">
            <div className="paddle-lab-download-icon">
                <i
                    style={{backgroundImage: `url(${IconWindows})`}}
                    className="paddle-lab-download-icon-icon"
                />
                <A
                    onClick={onWinClick}
                >
                    <Button
                        className="paddle-lab-download-icon-btn"
                        type="primary"
                        size="large"
                    >
                        WIN版下载
                    </Button>
                </A>
            </div>
            <div className="paddle-lab-download-icon">
                <i
                    style={{backgroundImage: `url(${IconMac})`}}
                    className="paddle-lab-download-icon-icon"
                />
                <A
                    onClick={onMacClick}
                >
                    <Button
                        className="paddle-lab-download-icon-btn"
                        type="primary"
                        size="large"
                    >
                        Mac版下载
                    </Button>
                </A>
            </div>
            <div className="paddle-lab-download-icon">
                <i
                    style={{backgroundImage: `url(${IconLinux})`}}
                    className="paddle-lab-download-icon-icon"
                />
                <A
                    onClick={onLinuxClick}
                >
                    <Button
                        className="paddle-lab-download-icon-btn"
                        type="primary"
                        size="large"
                    >
                        Linux版下载
                    </Button>
                </A>
            </div>
        </div>
    );
};

export default DownloadIcons;
